//Paquetes NPM de GYF.
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, ConciergeProxy, SagasHelper, LogsProxy } from 'com-gyf-webcore-servicehub';

import { Permission } from '../../../Common/Permission';
import UsuarioManager from '../../../Common/Managers/UsuarioManager';
import PerfilManager from '../../../Common/Managers/PerfilManager';

//Exportaci�n de constantes
export const SET_FUNCTIONS_ALTA_MOD_USUARIO = 'SET_FUNCTIONS_ALTA_MOD_USUARIO';
export const GET_DATA_ALTA_MOD_USUARIO_START = 'GET_DATA_ALTA_MOD_USUARIO_START';
export const GET_DATA_ALTA_MOD_USUARIO_SUCCESS = 'GET_DATA_ALTA_MOD_USUARIO_SUCCESS';
export const SET_SELECTED_USER_ID_ALTA_MOD_USUARIO = 'SET_SELECTED_USER_ID_ALTA_MOD_USUARIO';
export const GET_PERFILES_BY_PRODUCTO_FROM_ALTA_MOD_USUARIO = 'GET_PERFILES_BY_PRODUCTO_FROM_ALTA_MOD_USUARIO';
export const LIMPIAR_PERFILES_FILTRADOS = 'LIMPIAR_PERFILES_FILTRADOS';
export const GET_PERFILES_FROM_ALTA_MOD_USUARIO = 'GET_PERFILES_FROM_ALTA_MOD_USUARIO';
export const ADD_PERFIL_USUARIO_FROM_ALTA_MOD_USUARIO = 'ADD_PERFIL_USUARIO_FROM_ALTA_MOD_USUARIO';
export const DELETE_PERFIL_USUARIO_FROM_ALTA_MOD_USUARIO = 'DELETE_PERFIL_USUARIO_FROM_ALTA_MOD_USUARIO';
export const ADD_PERMISO_ALTA_MOD_USUARIO = 'ADD_PERMISO_ALTA_MOD_USUARIO';
export const DELETE_PERMISO_ALTA_MOD_USUARIO = 'DELETE_PERMISO_ALTA_MOD_USUARIO';
export const SELECT_PRODUCTO_PERMISOS_ALTA_MOD_USUARIO = 'SELECT_PRODUCTO_PERMISOS_ALTA_MOD_USUARIO';
export const SELECT_CATEGORIA_PERMISOS_ALTA_MOD_USUARIO = 'SELECT_CATEGORIA_PERMISOS_ALTA_MOD_USUARIO';
export const SELECT_PROGRAMA_PERMISOS_ALTA_MOD_USUARIO = 'SELECT_PROGRAMA_PERMISOS_ALTA_MOD_USUARIO';
export const ADD_FUNCION_ALTA_MOD_USUARIO = 'ADD_FUNCION_ALTA_MOD_USUARIO';
export const DELETE_FUNCION_ALTA_MOD_USUARIO = 'DELETE_FUNCION_ALTA_MOD_USUARIO';
export const ADD_MODO_EXCLUSIVO_FROM_ALTA_MOD_USUARIO = 'ADD_MODO_EXCLUSIVO_FROM_ALTA_MOD_USUARIO';
export const DELETE_MODO_EXCLUSIVO_FROM_ALTA_MOD_USUARIO = 'DELETE_MODO_EXCLUSIVO_FROM_ALTA_MOD_USUARIO';
export const SET_ACCESOS_PLATAFORMA_FROM_ALTA_MOD_USUARIO = 'SET_ACCESOS_PLATAFORMA_FROM_ALTA_MOD_USUARIO';
export const UPDATE_INFORMACION_USUARIO_FROM_ALTA_MOD_USUARIO = 'UPDATE_INFORMACION_USUARIO_FROM_ALTA_MOD_USUARIO';
export const SET_REDIRECT_TRUE_ALTA_MOD_USUARIO = 'SET_REDIRECT_TRUE_ALTA_MOD_USUARIO';
export const RESET_STATE_ALTA_MOD_USUARIO = 'RESET_STATE_ALTA_MOD_USUARIO';
export const SET_POPUP_ALTA_MOD_USUARIO = 'SET_POPUP_ALTA_MOD_USUARIO';
export const ESCONDER_POPUP_ALTA_MOD_USUARIO = 'ESCONDER_POPUP_ALTA_MOD_USUARIO';
export const GET_DATA_AD_ALTA_MOD_USUARIO_SUCCESS = 'GET_DATA_AD_ALTA_MOD_USUARIO_SUCCESS';
export const SET_PASSWORD_CHANGE_ALTA_MOD_USUARIO = 'SET_PASSWORD_CHANGE_ALTA_MOD_USUARIO';
export const SET_PASSWORD_UNCHANGE_ALTA_MOD_USUARIO = 'SET_PASSWORD_UNCHANGE_ALTA_MOD_USUARIO';
export const ADD_PRODUCTO_USUARIO_FROM_ALTA_MOD_USUARIO = 'ADD_PRODUCTO_USUARIO_FROM_ALTA_MOD_USUARIO';
export const ADD_GRUPO_WINDOWS_USUARIO = 'ADD_GRUPO_WINDOWS_USUARIO'
export const DELETE_GRUPO_WINDOWS_USUARIO = 'DELETE_GRUPO_WINDOWS_USUARIO'
export const RESET_GRUPO_WINDOWS_USUARIO = 'RESET_GRUPO_WINDOWS_USUARIO'
export const VALIDAR_COMBO_PERFILES = 'VALIDAR_COMBO_PERFILES'

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch, _currentScope, _userToEditId, _productoId, _perfilCodigo, _productId, _perfilDesc, _state = null;

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} userToEditId
 * @param {any} currentScope
 */
export function getData(userToEditId, currentScope) {
    LogHelper.In(getData.name, userToEditId, currentScope);

    return (dispatch, getState) => {
        const state = getState();
        _dispatch = dispatch;
        _currentScope = currentScope;
        _userToEditId = userToEditId;

        dispatch({ type: SET_SELECTED_USER_ID_ALTA_MOD_USUARIO, state, userToEditId });
        dispatch({ type: GET_DATA_ALTA_MOD_USUARIO_START, state });

        var currentScopeRequest = {
            "UserId": _currentScope.UserId,
            "ProductCode": _currentScope.ProductCode,
            "ProgramCode": _currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => getFunctionsCallback(data), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD");
    }
}

/**
 * Setea la informacion de usuario dependiendo la propiedad especificada.
 * @param {any} propToUpdate
 * @param {any} value
 */
export function updateInformacionUsuario(propToUpdate, value) {
    LogHelper.In(updateInformacionUsuario.name, propToUpdate, value);

    return (dispatch, getState) => {
        dispatch({ type: UPDATE_INFORMACION_USUARIO_FROM_ALTA_MOD_USUARIO, propToUpdate: propToUpdate, value: value });
    }
}

/**
 * Obtiene los perfiles por producto id.
 * @param {any} productoId
 */
export function getPerfilesByProducto(productoId) {
    LogHelper.In(getPerfilesByProducto.name, productoId);

    return (dispatch, getState) => {
        var localvalues = {
            'PRODUCT_ID': productoId
        }

        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_PERFILES_BY_PRODUCTO", "Get", _currentScope.ProductCode, "SEGURIDAD", 1, "Product");
        Engine1Proxy.Execute(getPerfilesByProductoCallback, null, null, "SEGURIDAD");
    }
}

/**
 * Setea el estado inicial de la lista de perfiles filtrados.
 * @param {any} productoId
 */
export function limpiarPerfilesFiltrados(productoId) {
    LogHelper.In(limpiarPerfilesFiltrados.name, productoId);

    return (dispatch, getState) => {
        dispatch({ type: LIMPIAR_PERFILES_FILTRADOS });
    }
}

/**
 * Da de alta un nuevo perfil.
 * @param {any} nombre
 * @param {any} descripcion
 * @param {any} productoId
 */
export function createPerfil(nombre, descripcion, productoId) {
    LogHelper.In(createPerfil.name, nombre, descripcion, productoId);

    _productoId = productoId;

    return (dispatch) => {
        _dispatch = dispatch;
        _perfilCodigo = nombre;
        _perfilDesc = descripcion;
        let state = getState().altaModUsuario.gruposWindowsSeleccionados;

        let gruposArray = [];

        state.forEach((x) => {
            let item = {
                'Descripcion': x.nombre
            };
            gruposArray.push(item);
        });

        let profile = {
            'CODIGO': nombre,
            'DESCRIPCION': descripcion,
            'PRODUCTO_ID': productoId,
            'FUNCIONALIDAD': [],
            'GRUPOS_WINDOWS': gruposArray
        }

        $("#perfil-modal").modal('hide');
        dispatch({ type: GET_DATA_ALTA_MOD_USUARIO_START });

        if (sessionStorage.getItem('PantallaCambios') == "true") {
            sessionStorage.removeItem('PantallaCambios');
        }

        LogHelper.Out(createPerfil.name, profile);
        PerfilManager.CreatePerfil(profile, SagasHelper.GetSagasId, ejecutarPorEstadoPerfil);
    }
}

/**
 * Setea el perfil elegido al usuario a dar de alta o editar.
 * @param {any} perfilCodigo
 */
export function addPerfilUsuario(perfilCodigo, productId) {
    LogHelper.In(addPerfilUsuario.name, perfilCodigo, productId);

    _productId = productId;

    return (dispatch, getState) => {
        dispatch({ type: ADD_PERFIL_USUARIO_FROM_ALTA_MOD_USUARIO, perfilCodigo, productId });
        dispatch({ type: LIMPIAR_PERFILES_FILTRADOS, perfilCodigo, productId });
    }
}

/**
 * Elimina el perfil elegido al usuario a dar de alta o editar.
 * @param {any} perfilId
 */
export function deletePerfilUsuario(perfilId) {
    LogHelper.In(deletePerfilUsuario.name, perfilId);

    return (dispatch, getState) => {
        dispatch({ type: DELETE_PERFIL_USUARIO_FROM_ALTA_MOD_USUARIO, perfilId });
    }
}

export function addProductoUsuario(productoCodigo) {
    LogHelper.In(addProductoUsuario.name, productoCodigo);

    return (dispatch, getState) => {
        dispatch({ type: ADD_PRODUCTO_USUARIO_FROM_ALTA_MOD_USUARIO, productoCodigo });
    }
}

/**
 * Agrega panel de permisos para el usuario.
 */
export function addPermiso() {
    LogHelper.In(addPermiso.name);

    return (dispatch, getState) => {
        let state = JSON.parse(JSON.stringify(getState().altaModUsuario));
        let permisos = state.permisos;
        let ultimoPermiso;

        if (permisos.length > 0) {
            ultimoPermiso = permisos[permisos.length - 1];
        }

        let permiso = new Permission((ultimoPermiso) ? ultimoPermiso.id + 1 : 1, state.productos, state.categorias, state.programas, state.funciones, false);

        permisos.push(permiso);

        dispatch({ type: ADD_PERMISO_ALTA_MOD_USUARIO, permisos });
    }
}

/**
 * Elimina un panel de permisos para el usuario.
 * @param {any} permisoId
 */
export function deletePermiso(permisoId) {
    LogHelper.In(deletePermiso.name, permisoId);

    return (dispatch) => {
        dispatch({ type: DELETE_PERMISO_ALTA_MOD_USUARIO, permisoId });
    }
}

/**
 * Filtra el producto en cascada y actualiza la lista de funciones.
 * @param {any} idPermiso
 * @param {any} idProducto
 */
export function selectProductoPermiso(idPermiso, idProducto) {
    LogHelper.In(selectProductoPermiso.name, idPermiso, idProducto);

    return (dispatch, getState) => {
        let state = JSON.parse(JSON.stringify(getState().altaModUsuario));
        let localValue = {
            'PRODUCT_ID': (idProducto == 0) ? undefined : idProducto,
            'CATEGORY_ID': undefined,
            'PROGRAM_ID': undefined
        }

        Engine1Proxy.AddDataSourcesRequests(localValue, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

        Engine1Proxy.Execute((data) => _funcionalidadesProductoCallback(data, idPermiso, idProducto), null, null, "SEGURIDAD");
    }
}

/**
 * Filtra la categoria en cascada y actualiza la lista de funciones.
 * @param {any} idPermiso
 * @param {any} idCategoria
 */
export function selectCategoriaPermiso(idPermiso, idCategoria) {
    LogHelper.In(selectCategoriaPermiso.name, idPermiso, idCategoria);

    return (dispatch, getState) => {
        let state = JSON.parse(JSON.stringify(getState().altaModUsuario));
        let localValue = {
            'PRODUCT_ID': state.permisos.find(x => x.id == idPermiso).productoId,
            'CATEGORY_ID': (idCategoria == 0) ? undefined : idCategoria,
            'PROGRAM_ID': undefined
        }

        Engine1Proxy.AddDataSourcesRequests(localValue, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

        Engine1Proxy.Execute((data) => _funcionalidadesCategoriaCallback(data, idPermiso, idCategoria), null, null, "SEGURIDAD");
    }
}

/**
 * Filtra el programa en cascada y actualiza la lista de funciones.
 * @param {any} idPermiso
 * @param {any} idPrograma
 */
export function selectProgramaPermiso(idPermiso, idPrograma) {
    LogHelper.In(selectProgramaPermiso.name, idPermiso, idPrograma);

    return (dispatch, getState) => {
        let state = JSON.parse(JSON.stringify(getState().altaModUsuario));
        let localValue = {
            'PRODUCT_ID': state.permisos.find(x => x.id == idPermiso).productoId,
            'CATEGORY_ID': state.permisos.find(x => x.id == idPermiso).categoriaId,
            'PROGRAM_ID': (idPrograma == 0) ? undefined : idPrograma
        }

        Engine1Proxy.AddDataSourcesRequests(localValue, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

        Engine1Proxy.Execute((data) => _funcionalidadesProgramaCallback(data, idPermiso, idPrograma), null, null, "SEGURIDAD");
    }
}

/**
 * Agrega una funcion al permiso
 * @param {any} idPermiso
 * @param {any} idFuncion
 * @param {any} flag - true = otorgaci�n del permiso - false = restricci�n del permiso
 */
export function addFuncion(idPermiso, idFuncion, flag) {
    LogHelper.In(addFuncion.name, idPermiso, idFuncion, flag);

    return (dispatch) => {
        dispatch({ type: ADD_FUNCION_ALTA_MOD_USUARIO, idPermiso, idFuncion, flag });
    }
}

/**
 * Elimina una funcion del permiso
 * @param {any} idPermiso
 * @param {any} idFuncion
 */
export function removeFuncion(idPermiso, idFuncion) {
    LogHelper.In(removeFuncion.name, idPermiso, idFuncion);

    return (dispatch) => {
        dispatch({ type: DELETE_FUNCION_ALTA_MOD_USUARIO, idPermiso, idFuncion });
    }
}

/**
 * Agrega un modo exclusivo para el usuario.
 * @param {any} modoExclusivo
 */
export function addModoExclusivo(modoExclusivo) {
    LogHelper.In(addModoExclusivo.name, modoExclusivo);

    return (dispatch, getState) => {
        dispatch({ type: ADD_MODO_EXCLUSIVO_FROM_ALTA_MOD_USUARIO, modoExclusivo });
    }
}

/**
 * Elimina un modo exclusivo para el usuario.
 * @param {any} modoExclusivo
 */
export function deleteModoExclusivo(modoExclusivo) {
    LogHelper.In(deleteModoExclusivo.name, modoExclusivo);

    return (dispatch, getState) => {
        dispatch({ type: DELETE_MODO_EXCLUSIVO_FROM_ALTA_MOD_USUARIO, modoExclusivo });
    }
}

/**
 * Setea la cantidad de accesos simultaneos para la plataforma correspondiente para un usuario.
 * @param {any} plataformaId
 * @param {any} plataforma
 */
export function setAccesosSimultaneosPorPlataforma(plataformaId, plataforma) {
    LogHelper.In(setAccesosSimultaneosPorPlataforma.name, plataformaId, plataforma);

    return (dispatch, getState) => {
        dispatch({ type: SET_ACCESOS_PLATAFORMA_FROM_ALTA_MOD_USUARIO, plataformaId, plataforma });
    }
}

function validarPerfilProducto(state) {
    let isValid = true;
    if (state.informacionUsuario.ProductId != undefined && state.informacionUsuario.ProductId != '-1') {
        isValid = state.informacionUsuario.ProfileId != undefined;// || state.productoSinPerfil == false;
    }
    return isValid;
}

function validarPermisos(state) {
    const productos = state.productos;
    const categorias = state.categorias;
    const programas = state.programas;
    let permisos = state.permisos;
    var msjErrorPermisos = null;

    productos.map((prod) => {
        categorias.map((cat) => {
            programas.map((prog) => {
                var permisosEncontrados = permisos.filter(p => p.productoId == prod.Id && p.categoriaId == cat.Id && p.programaId == prog.Id);
                if (permisosEncontrados.length > 1)
                    msjErrorPermisos = "Existen una o mas asignaciones de permisos duplicadas, por favor corrija esto para continuar.";
            })
        })
    });
    return msjErrorPermisos;
}

/**
 * Da de alta un nuevo usuario.
 */
export function createUsuario() {
    LogHelper.In(createUsuario.name);

    return (dispatch, getState) => {
        dispatch({ type: GET_DATA_ALTA_MOD_USUARIO_START });

        const state = getState().altaModUsuario;
        let permisosValidados = validarPermisos(state);
        let isValid = validarPerfilProducto(state)

        if (!permisosValidados) {
            if (isValid) {

                if (state.informacionUsuario.Clave) {

                    _state = state;

                    let parameters = [];
                    let permissions = [];
                    let exclusiveModes = [];
                    var plataforms = [];
                    let profiles = [];

                    _state.permisos.forEach(p => {
                        p.funciones.forEach(f => {
                            parameters = {
                                "PERMISO": (f.flag) ? 1 : 0,
                                "PRODUCTO_ID": (p.productoId == 0) ? undefined : p.productoId,
                                "PROGRAMA_ID": (p.programaId == 0) ? undefined : p.programaId,
                                "CATEGORIA_ID": (p.categoriaId == 0) ? undefined : p.categoriaId,
                                "FUNCION_ID": f.id
                            };

                            permissions.push(parameters);
                        });
                    });

                    _state.modoExclusivo.forEach(function (value) {
                        let parameters = {
                            "PRODUCTO_ID": value
                        }

                        if (value !== 0)
                            exclusiveModes.push(parameters);
                    });

                    _state.accesosPorPlataforma.forEach(function (p) {
                        let parameters = {
                            "CANLOG": p.value,
                            "CANACT": 0,
                            "TIPO_PLATAFORMA_ID": p.plataformaId
                        }

                        plataforms.push(parameters);
                    });

                    _state.perfilesDelUsuario.forEach(function (p) {
                        let parameters = {
                            "PERFIL_ID": p.PerfilId
                        }

                        profiles.push(parameters);
                    });

                    let changePass = (state.informacionUsuario.Cambio_Clave != undefined) ? state.informacionUsuario.Cambio_Clave : state.esSeguridadGyf;
                    let plataformaId = (state.informacionUsuario.PlataformaId != undefined) ? state.informacionUsuario.PlataformaId : state.plataformaId;
                    let nuevoUsuario = {
                        "NOMBRE": state.informacionUsuario.Nombre.trim(),
                        "LOGIN": state.informacionUsuario.Login,
                        "CODIGO_PERSONA": null,
                        "EMAIL": state.informacionUsuario.Email,
                        "DIAS_VIGENCIA_CLAVE": null,
                        "LOGIN_NT": state.informacionUsuario.Login,
                        "BLOQUEADO": 0,
                        "BLOQUEADO_INACTIVIDAD": 0,
                        "CLAVE": state.informacionUsuario.Clave,
                        "CAMBIO_CLAVE": changePass,
                        "CANT_CAMBIOS_CLAVE": null,
                        "ULTIMO_CAMBIO_CLAVE": null,
                        "ACTIVO": 1,
                        "SECTOR_ID": state.informacionUsuario.SectorId,
                        "TIPO_DOCUMENTO": null,
                        "DOCUMENTO": null,
                        "PERMISOS": permissions,
                        "EXCLUSIVEMODES": exclusiveModes,
                        "PLATAFORMAS": plataforms,
                        "PERFILES": profiles,
                        "SUCURSAL_ID": state.informacionUsuario.SucursalId,
                        "PLATAFORMA_ID": plataformaId
                    };

                    if (sessionStorage.getItem('PantallaCambios') == "true") {
                        sessionStorage.removeItem('PantallaCambios');
                    }
                    LogHelper.Out(createUsuario.name);
                    UsuarioManager.GuardarUsuario(nuevoUsuario, SagasHelper.GetSagasId, ejecutarPorEstado);
                }
                else {
                    let message = {
                        value: "Debe ingresar una contrase\u00F1a v\u00E1lida.",
                        class: "error"
                    };

                    _dispatch({ type: SET_POPUP_ALTA_MOD_USUARIO, message });
                }
            } else {
                _dispatch({ type: VALIDAR_COMBO_PERFILES })
            }
        } else {
            let message = {
                value: permisosValidados,
                class: "error"
            };

            _dispatch({ type: SET_POPUP_ALTA_MOD_USUARIO, message });
        }
    }
}
/**
 * Edita un usuario.
 */
export function editUsuario() {
    LogHelper.In(editUsuario.name);

    return (dispatch, getState) => {
        dispatch({ type: GET_DATA_ALTA_MOD_USUARIO_START });

        const state = getState().altaModUsuario;
        let permisosValidados = validarPermisos(state);
        let isValid = validarPerfilProducto(state)

        if (!permisosValidados) {
            if (isValid) {

                if (state.passWordChange && !state.informacionUsuario.Clave) {

                    let message = {
                        value: "Debe ingresar una contrase\u00F1a v\u00E1lida.",
                        class: "error"
                    };

                    _dispatch({ type: SET_POPUP_ALTA_MOD_USUARIO, message });

                } else {
                    _state = state;

                    let parameters = [];
                    let permissions = [];
                    let exclusiveModes = [];
                    var plataforms = [];
                    let profiles = [];

                    _state.permisos.forEach(p => {
                        p.funciones.forEach(f => {
                            parameters = {
                                "PERMISO": (f.flag) ? 1 : 0,
                                "PRODUCTO_ID": (p.productoId == 0) ? undefined : p.productoId,
                                "PROGRAMA_ID": (p.programaId == 0) ? undefined : p.programaId,
                                "CATEGORIA_ID": (p.categoriaId == 0) ? undefined : p.categoriaId,
                                "FUNCION_ID": f.id
                            };

                            permissions.push(parameters);
                        });
                    });

                    _state.modoExclusivo.forEach(function (value) {
                        let parameters = {
                            "PRODUCTO_ID": value
                        }

                        if (value !== 0)
                            exclusiveModes.push(parameters);
                    });

                    _state.tipoPlataforma.forEach(function (p) {
                        let parameters = {
                            "CANLOG": p.CanLog,
                            "CANACT": 0,
                            "TIPO_PLATAFORMA_ID": p.Id
                        }

                        plataforms.push(parameters);
                    });

                    _state.perfilesDelUsuario.forEach(function (p) {
                        let parameters = {
                            "PERFIL_ID": p.PerfilId
                        }

                        profiles.push(parameters);
                    });

                    let changePass = (_state.informacionUsuario.Cambio_Clave != undefined) ? _state.informacionUsuario.Cambio_Clave : _state.esSeguridadGyf;
                    let usuarioEditado = {
                        "USUARIO_ID": _userToEditId,
                        "NOMBRE": _state.informacionUsuario.Nombre.trim(),
                        "LOGIN": _state.informacionUsuario.Login,
                        "CODIGO_PERSONA": null,
                        "EMAIL": _state.informacionUsuario.Email,
                        "DIAS_VIGENCIA_CLAVE": null,
                        "LOGIN_NT": _state.informacionUsuario.Login,
                        "BLOQUEADO": 0,
                        "BLOQUEADO_INACTIVIDAD": 0,
                        "CLAVE": _state.passWordChange ? _state.informacionUsuario.Clave : "",
                        "CAMBIO_CLAVE": changePass,
                        "CANT_CAMBIOS_CLAVE": null,
                        "ULTIMO_CAMBIO_CLAVE": changePass,
                        "ACTIVO": 1,
                        "SECTOR_ID": _state.informacionUsuario.SectorId,
                        "TIPO_DOCUMENTO": null,
                        "DOCUMENTO": null,
                        "PERMISOS": permissions,
                        "EXCLUSIVEMODES": exclusiveModes,
                        "PLATAFORMAS": plataforms,
                        "PERFILES": profiles,
                        "SUCURSAL_ID": _state.informacionUsuario.SucursalId,
                        "PLATAFORMA_ID": state.informacionUsuario.PlataformaId
                    };

                    if (sessionStorage.getItem('PantallaCambios') == "true") {
                        sessionStorage.removeItem('PantallaCambios');
                    }

                    UsuarioManager.GuardarUsuario(usuarioEditado, SagasHelper.GetSagasId, ejecutarPorEstado);

                }

            } else {
                _dispatch({ type: VALIDAR_COMBO_PERFILES })

            }

        } else {
            let message = {
                value: permisosValidados,
                class: "error"
            };

            _dispatch({ type: SET_POPUP_ALTA_MOD_USUARIO, message });
        }
    }
}

/**
 * Redirecciona a lista de usuarios al cancelar
 */
export function cancelClick() {
    LogHelper.In(cancelClick.name);
    if (sessionStorage.getItem('PantallaCambios') == "true") {
        sessionStorage.removeItem('PantallaCambios');
    }

    return (dispatch) => {
        dispatch({ type: SET_REDIRECT_TRUE_ALTA_MOD_USUARIO });
    }
}

/**
 * Resetea el estado inicial
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: RESET_STATE_ALTA_MOD_USUARIO });
    }
}

/**
 * Esconde popup de error.
 */
export function hidePopUp() {
    LogHelper.In(hidePopUp.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ESCONDER_POPUP_ALTA_MOD_USUARIO });
    }
}

/**
 * Indica que la contrase�a ha sido modificada, permite detectar el momento de loggeo
 * del blanqueo de la misma.
 */

export function passWordChange() {
    return (dispatch) => {
        _dispatch({ type: SET_PASSWORD_CHANGE_ALTA_MOD_USUARIO });
    }
}

/**
 * Indica que la modificacion de la contrase�a ha sido cancelada, permite detectar el momento de loggeo
 * del blanqueo de la misma.
 */

export function passWordUnChange() {
    return (dispatch) => {
        _dispatch({ type: SET_PASSWORD_UNCHANGE_ALTA_MOD_USUARIO });
    }
}

export function addGroupWindows(grupo) {
    return (dispatch) => {
        dispatch({ type: ADD_GRUPO_WINDOWS_USUARIO, grupo: grupo });
    }
}


export function deleteGroupWindows(grupo) {
    return (dispatch) => {
        dispatch({ type: DELETE_GRUPO_WINDOWS_USUARIO, grupo: grupo })
    }
}

export function resetGrupoWindows() {
    return (dispatch) => {
        dispatch({ type: RESET_GRUPO_WINDOWS_USUARIO })
    }
}

/**--------------------------- FUNCIONES AUXILIARES ----------------------------**/

/**
 * Funcion callback de la obtencion de las funciones del usuario.
 * @param {any} data
 */
function getFunctionsCallback(data) {
    LogHelper.In(getFunctionsCallback.name, data);

    let localvalues = null;

    let functions = data.SEGURIDAD;
    functions.forEach(p => { functions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_FUNCTIONS_ALTA_MOD_USUARIO, functions });

    if (functions.Consulta == true) {
        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_PERFILES", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);
        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_SUCURSALES", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);
        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_SECTORES", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);
        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_PRODUCTOS", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);
        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_CATEGORIAS", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);
        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_PROGRAMAS", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);
        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_TIPO_PLATAFORMA", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);
        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_ALL_USERLOGINS", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);
        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_CONFIGURATION_PASSWORD_SESION", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);
        Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_CONFIGURATION_PASSWORD_TYPE", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);
        Engine1Proxy.AddDataSourcesRequests(null, 'SP_GET_FUNCTIONS_BY_PERMISSION', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_ALL_USUARIOS', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');

        //Editar usuario
        if (_userToEditId != undefined && _userToEditId != 0) {
            localvalues = { "USUARIO_ID": _userToEditId }

            Engine1Proxy.AddRuleRequests(localvalues, "GetUsuarioById", "Concierge", "SEGURIDAD");
            Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_CANLOG_BY_USUARIO_ID", "Get",
                _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "User", true);
            Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_PERFIL_USUARIO", "Get",
                _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "User", true);
            Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_PERMISOS_BY_USUARIO", "Get",
                _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "User", true);
            Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_MODO_EXCLUSIVO_BY_USER_ID", "Get",
                _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "User", true);
        }

        LogHelper.Out(getFunctionsCallback.name);
        Engine1Proxy.Execute(getDataCallback, null, null, "SEGURIDAD");
    }
}

/**
 * Funcion callback de la obtencion de los datos principales para popular la pantalla.
 * @param {any} data
 */
function getDataCallback(data) {
    LogHelper.In(getDataCallback.name, data);

    let result = {
        "CONFIGURATION_PASSWORD_SESION": JSON.parse(data.GET_CONFIGURATION_PASSWORD_SESION).Recordset0.Rows[0],
        "CONFIGURATION_PASSWORD_TYPE": JSON.parse(data.GET_CONFIGURATION_PASSWORD_TYPE).Recordset0.Rows[0],
        "GET_SUCURSALES": JSON.parse(data.GET_SUCURSALES).Recordset0.Rows,
        "GET_PERFILES": JSON.parse(data.GET_PERFILES).Recordset0.Rows,
        "GET_SECTORES": JSON.parse(data.GET_SECTORES).Recordset0.Rows,
        "GET_TIPO_PLATAFORMA": JSON.parse(data.GET_TIPO_PLATAFORMA).Recordset0.Rows,
        "GET_CATEGORIAS": JSON.parse(data.GET_CATEGORIAS).Recordset0.Rows,
        "GET_PRODUCTOS": JSON.parse(data.GET_PRODUCTOS).Recordset0.Rows,
        "GET_PROGRAMAS": JSON.parse(data.GET_PROGRAMAS).Recordset0.Rows,
        "GET_FUNCIONES": JSON.parse(data.SP_GET_FUNCTIONS_BY_PERMISSION).Recordset3.Rows,
        "GET_ALL_USUARIOS": JSON.parse(data.GET_ALL_USUARIOS).Recordset0.Rows,
        "USER_ACCESS_BY_PLATAFORM": [],
        "USER_EXCLUSIVE_MODE": [],
        "USER_INFO": {},
        "USER_PROFILES": [],
        "USER_PERMISSION_COMBOS": [],
        "GRUPOS_WINDOWS": []
    };

    //Modo edicion
    if (_userToEditId != undefined && _userToEditId != 0) {
        //Cargo los datos del usuario
        result.USER_INFO = JSON.parse(data.GetUsuarioById);

        //Cargo el modo exclusivo
        result.USER_EXCLUSIVE_MODE = JSON.parse(data.GET_MODO_EXCLUSIVO_BY_USER_ID).Recordset0.Rows.map(function (xm) {
            return xm.ProductoId;
        });

        //Cargo los valores del tipo plataforma
        result.USER_ACCESS_BY_PLATAFORM = JSON.parse(data.GET_CANLOG_BY_USUARIO_ID).Recordset0.Rows.map(function (can) {
            return { plataformaId: can.TipoPlataformaId, value: can.CanLog };
        });

        //Agrego los perfiles asociados al usuario
        result.USER_PROFILES = JSON.parse(data.GET_PERFIL_USUARIO).Recordset0.Rows.map(function (per) {
            return {
                PerfilId: per.PerfilId,
                PerfilDescripcion: per.PerfilDescripcion,
                PerfilCodigo: per.PerfilCodigo,
                ProductoId: per.ProductoId,
                ProductoDescripcion: per.ProductoDescripcion ? per.ProductoDescripcion : 'Todos los productos'
            };
        });

        //Agrego los permisos
        let permisos = JSON.parse(data.GET_PERMISOS_BY_USUARIO).Recordset0.Rows;

        if (permisos.length > 0) {
            let funciones = [];
            result.GET_FUNCIONES.forEach(f => {
                funciones.push({
                    id: f.Id,
                    descripcion: f.Descripcion
                });
            });

            //Agrego el primer permiso
            result.USER_PERMISSION_COMBOS.push({
                id: 1,
                productoId: permisos[0].ProductoId,
                categoriaId: permisos[0].CategoriaId,
                programaId: permisos[0].ProgramaId,
                funciones: [{ id: permisos[0].FuncionId, descripcion: permisos[0].Funcion, flag: permisos[0].Permiso }],
                listaProductos: result.GET_PRODUCTOS,
                listaCategorias: result.GET_CATEGORIAS,
                listaProgramas: result.GET_PROGRAMAS,
                listaFunciones: funciones
            });

            //Iteraci�n entre los dem�s permisos            
            permisos.forEach(p => {
                //Valido si el permiso ya existe
                let existePermiso = result.USER_PERMISSION_COMBOS.find(x => x.productoId == p.ProductoId &&
                    x.categoriaId == p.CategoriaId &&
                    x.programaId == p.ProgramaId);

                if (existePermiso) {
                    //Valido si la funci�n ya existe
                    if (!existePermiso.funciones.find(x => x.id == p.FuncionId)) {
                        result.USER_PERMISSION_COMBOS.find(x => x.productoId == p.ProductoId &&
                            x.categoriaId == p.CategoriaId &&
                            x.programaId == p.ProgramaId).funciones.push({ id: p.FuncionId, descripcion: p.Funcion, flag: p.Permiso });
                    }
                }
                else {
                    let lastPermission = result.USER_PERMISSION_COMBOS[result.USER_PERMISSION_COMBOS.length - 1];

                    result.USER_PERMISSION_COMBOS.push({
                        id: lastPermission.id + 1,
                        productoId: p.ProductoId,
                        categoriaId: p.CategoriaId,
                        programaId: p.ProgramaId,
                        funciones: [{ id: p.FuncionId, descripcion: p.Funcion, flag: p.Permiso }],
                        listaProductos: result.GET_PRODUCTOS,
                        listaCategorias: result.GET_CATEGORIAS,
                        listaProgramas: result.GET_PROGRAMAS,
                        listaFunciones: funciones
                    });
                }
            });
        }

        if (result.CONFIGURATION_PASSWORD_TYPE.TipoSeguridad == "AD") {
            //Asocio perfil con producto
            result.USER_PROFILES.forEach((perfil) => {
                if (perfil.ProductoId != null) {
                    result.GET_PRODUCTOS.forEach((producto) => {
                        if (perfil.ProductoId == producto.Id) {
                            perfil.Producto = producto.Descripcion;
                        }
                    });
                }
                else {
                    perfil.Producto = "Todos los productos";
                }
            });

            //Grupos AD
            let localvalues = { "USUARIO": (result.USER_INFO.Login_NT) ? result.USER_INFO.Login_NT : "" };

            Engine1Proxy.AddDataSourcesRequests(localvalues, "GET_GROUPS_BY_USER_AD", "Get",
                _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "User", true);

            LogHelper.Out(getDataCallback.name);
            Engine1Proxy.Execute(getDataCallbackADGroups, null, null, "SEGURIDAD");
        }
    }
    //Alta de usuario
    else {
        //Cargo los valores del tipo plataforma seteados por default
        result.USER_ACCESS_BY_PLATAFORM = JSON.parse(data.GET_TIPO_PLATAFORMA).Recordset0.Rows.map(function (plat) {
            return { plataformaId: plat.Id, value: plat.CanLog };
        });
    }

    LogHelper.Out(getDataCallback.name);
    _dispatch({ type: GET_DATA_ALTA_MOD_USUARIO_SUCCESS, result });
}

/**
 * Funcion callback de la obtenci�n de grupos AD del usuario a editar
 * @param {any} data
 */
function getDataCallbackADGroups(data) {
    //Valido si hubo error en la consulta de AD.
    let ADResult = JSON.parse(data.GET_GROUPS_BY_USER_AD).Recordset0.Rows[0];
    let gruposWindows = [];

    if (ADResult.IsError) {
        gruposWindows = [{ nombre: 'Hubo un error al consultar la informaci�n AD' }];
    }
    else {
        //Mapeo de grupos de AD.        
        ADResult = JSON.parse(ADResult.Result);
        ADResult.forEach((g) => {
            gruposWindows.push({ nombre: g });
        });
    }

    _dispatch({ type: GET_DATA_AD_ALTA_MOD_USUARIO_SUCCESS, gruposWindows });
}

/**
 * Funcion callback de la obtencion de los perfiles por producto.
 * @param {any} data
 */
function getPerfilesByProductoCallback(data) {
    LogHelper.In(getPerfilesByProductoCallback.name, data);

    let result = null;

    result = {
        'GET_PERFILES_BY_PRODUCTO': JSON.parse(data.GET_PERFILES_BY_PRODUCTO).Recordset0.Rows != undefined ? JSON.parse(data.GET_PERFILES_BY_PRODUCTO).Recordset0.Rows : null,
    }

    _dispatch({ type: GET_PERFILES_BY_PRODUCTO_FROM_ALTA_MOD_USUARIO, result });
}

/**
 * Callback de funcionalidades al seleccionar un producto
 * @param {any} data
 * @param {any} idPermiso
 * @param {any} idProducto
 */
function _funcionalidadesProductoCallback(data, idPermiso, idProducto) {
    LogHelper.In(_funcionalidadesProductoCallback.name, data, idPermiso, idProducto);

    let result = {
        idPermiso,
        idProducto,
        funciones: JSON.parse(data.SP_GET_FUNCTIONS_BY_PERMISSION).Recordset3.Rows
    };

    _dispatch({ type: SELECT_PRODUCTO_PERMISOS_ALTA_MOD_USUARIO, result });
}

/**
 * Callback de funcionalidades al seleccionar una categoria
 * @param {any} data
 * @param {any} idPermiso
 * @param {any} idCategoria
 */
function _funcionalidadesCategoriaCallback(data, idPermiso, idCategoria) {
    LogHelper.In(_funcionalidadesCategoriaCallback.name, data, idPermiso, idCategoria);

    let result = {
        idPermiso: idPermiso,
        idCategoria: idCategoria,
        funciones: JSON.parse(data.SP_GET_FUNCTIONS_BY_PERMISSION).Recordset3.Rows
    };

    _dispatch({ type: SELECT_CATEGORIA_PERMISOS_ALTA_MOD_USUARIO, result });
}

/**
 * Callback de funcionalidades al seleccionar un programa
 * @param {any} data
 * @param {any} idPermiso
 * @param {any} idPrograma
 */
function _funcionalidadesProgramaCallback(data, idPermiso, idPrograma) {
    LogHelper.In(_funcionalidadesProgramaCallback.name, data, idPermiso, idPrograma);

    let result = {
        idPermiso: idPermiso,
        idPrograma: idPrograma,
        funciones: JSON.parse(data.SP_GET_FUNCTIONS_BY_PERMISSION).Recordset3.Rows
    };

    _dispatch({ type: SELECT_PROGRAMA_PERMISOS_ALTA_MOD_USUARIO, result });
}

/**
 * Callback de llamado a Sagas en el alta/edici�n de usuario
 * @param {any} result
 * @param {any} disconectCallback
 */
function ejecutarPorEstado(result, disconectCallback) {
    let message;

    switch (result.Estado) {
        case 2:
            LogAltaUsuario();

            break;

        case 3:
            message = {
                value: "Hubo un error al procesar la transacci\u00F3n.",
                class: "error"
            };

            _dispatch({ type: SET_POPUP_ALTA_MOD_USUARIO, message });

            break;

        case 5:
            message = {
                value: "Hubo un error al procesar la transacci\u00F3n.",
                class: "error"
            };

            _dispatch({ type: SET_POPUP_ALTA_MOD_USUARIO, message });

            break;

        default:

            message = {
                value: "Hubo un error al procesar la transacci\u00F3n.",
                class: "error"
            };

            _dispatch({ type: SET_POPUP_ALTA_MOD_USUARIO, message });

            break;
    }

    disconectCallback();
}

/**
 * Realiza el logeo de operaci�n en el alta de usuario
 */
function LogAltaUsuario() {
    let action = null;
    let tags = null;
    const state = _state;

    let sucursal = state.sucursales.filter(x => x.Id == state.informacionUsuario.SucursalId)[0].Descripcion;
    let sucursalCodigo = state.sucursales.filter(x => x.Id == state.informacionUsuario.SucursalId)[0].CODIGO;
    sucursalCodigo = (sucursalCodigo ? sucursalCodigo : "");
    let sector = state.sectores.filter(x => x.Id == state.informacionUsuario.SectorId)[0].Descripcion;

    if (_userToEditId != undefined && _userToEditId != 0) {

        tags = "SEGURIDAD,MODIFICACION,USUARIO";
        action = GenerarAction(state.initialData, state.informacionUsuario, state.sucursales, state.sectores);

        if (action.length > 0)
            LogsProxy.SaveOperationLog(tags, action, null, null, null, null, null, "SEGURIDAD");

        if (state.passWordChange) {
            tags = "SEGURIDAD,BLANQUEO,CONTRASE�A";
            action = "Modificaci�n de Contrase�a para el Usuario: " + state.informacionUsuario.Login + " - " + state.informacionUsuario.Nombre + " ; de la Sucursal: " + sucursalCodigo + " " + sucursal + " " + " ; del Sector:  " + sector;
            LogsProxy.SaveOperationLog(tags, action, null, null, null, null, null, "SEGURIDAD");
        }

        _dispatch({ type: SET_REDIRECT_TRUE_ALTA_MOD_USUARIO }); //TODO: Unificar logs en 1 llamado
    }
    else {
        tags = "SEGURIDAD,ALTA,USUARIO";
        action = "Alta del Usuario: " + state.informacionUsuario.Login + " - " + state.informacionUsuario.Nombre + " ; de la Sucursal: " + sucursalCodigo + " " + sucursal + " " + " ; del Sector:  " + sector;
        LogsProxy.SaveOperationLog(tags, action, null, null, saveLogCallback, null, null, "SEGURIDAD");
    }
}

/**
 * Genera el action con los datos del usuario que fueron modificados
 * @param {any} initalUser
 * @param {any} finalUser
 * @param {any} sucursales
 * @param {any} sectores
 */
function GenerarAction(initalUser, finalUser, sucursales, sectores) {
    let action = "Usuario " + finalUser.Login + " ";
    let modify = false;

    let sucursalInicial = sucursales.filter(x => x.Id == initalUser.SucursalId).length > 0 ? sucursales.filter(x => x.Id == initalUser.SucursalId)[0].Descripcion : "";
    let sucursalInicialCodigo = sucursales.filter(x => x.Id == initalUser.SucursalId).length > 0 ? sucursales.filter(x => x.Id == initalUser.SucursalId)[0].CODIGO : "";
    sucursalInicialCodigo = (sucursalInicialCodigo ? sucursalInicialCodigo : "");
    let sectorInicial = sectores.filter(x => x.Id == initalUser.SectorId).length > 0 ? sectores.filter(x => x.Id == initalUser.SectorId)[0].Descripcion : "";

    let sucursalFinal = sucursales.filter(x => x.Id == finalUser.SucursalId)[0].Descripcion;
    let sucursalFinalCodigo = sucursales.filter(x => x.Id == finalUser.SucursalId)[0].CODIGO;
    sucursalFinalCodigo = (sucursalFinalCodigo ? sucursalFinalCodigo : "");
    let sectorfinal = sectores.filter(x => x.Id == finalUser.SectorId)[0].Descripcion;

    if (initalUser.Nombre != finalUser.Nombre) {
        action += "Nombre anterior: " + initalUser.Nombre + " Nombre actual: " + finalUser.Nombre + "; ";
        modify = true;
    }

    if (initalUser.Login != finalUser.Login) {
        action += "Login anterior: " + initalUser.Login + " Login actual: " + finalUser.Login + "; ";
        modify = true;
    }

    if (sucursalInicial != sucursalFinal) {
        action += "Sucursal anterior: " + sucursalInicialCodigo + "-" + sucursalInicial + " Sucursal actual: " + sucursalFinalCodigo + "-" + sucursalFinal + "; ";
        modify = true;
    }

    if (sectorInicial != sectorfinal) {
        action += "Sector anterior: " + sectorInicial + " Sector actual: " + sectorfinal + "; ";
        modify = true;
    }

    if (initalUser.Email != finalUser.Email) {
        action += "Email anterior: " + initalUser.Email + " Email actual: " + finalUser.Email + "; ";
        modify = true;
    }

    if (modify)
        return action;
    else
        return "";
}

/**
 * Callback del logeo al dar de alta un usuario
 * @param {any} data
 */
function saveLogCallback(data) {
    _dispatch({ type: SET_REDIRECT_TRUE_ALTA_MOD_USUARIO });
}

/**
 * Callback de llamado a Sagas en el alta/edici�n de usuario
 * @param {any} result
 * @param {any} disconectCallback
 */
function ejecutarPorEstadoPerfil(result, disconectCallback) {
    let message;

    switch (result.Estado) {
        case 2:
            LogAltaPerfil();

            break;

        case 3:
            message = {
                value: "Hubo un error al procesar la transacci\u00F3n.",
                class: "error"
            };

            _dispatch({ type: SET_POPUP_ALTA_MOD_USUARIO, message });

            break;

        case 5:
            message = {
                value: "Hubo un error al procesar la transacci\u00F3n.",
                class: "error"
            };

            _dispatch({ type: SET_POPUP_ALTA_MOD_USUARIO, message });

            break;

        default:

            message = {
                value: "Hubo un error al procesar la transacci\u00F3n.",
                class: "error"
            };

            _dispatch({ type: SET_POPUP_ALTA_MOD_USUARIO, message });

            break;
    }

    disconectCallback();
}

/**
 * Logea el alta de un perfil
 */
function LogAltaPerfil() {
    LogHelper.In(LogAltaPerfil.name);

    LogHelper.Out(LogAltaPerfil.name, LogsProxy.SaveOperationLog.name, "ALTA,PERFIL");
    LogsProxy.SaveOperationLog("SEGURIDAD,ALTA,PERFIL", "Alta del perfil " + _perfilDesc,
        null, null, nuevoPerfilLogCallback, null, null, "SEGURIDAD");
}

/**
 * Callback del logeo del alta de perfil. Busca la nueva lista de perfiles
 */
function nuevoPerfilLogCallback() {
    LogHelper.In(LogAltaPerfil.name);

    Engine1Proxy.AddDataSourcesRequests(null, "GET_PERFILES", "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product", true);
    Engine1Proxy.Execute(getPerfilesCallback, null, null, "SEGURIDAD");
}

/**
 * Funcion callback de la busqueda de perfiles.
 * @param {any} data
 */
function getPerfilesCallback(data) {
    LogHelper.In(getPerfilesCallback.name, data);

    let result = null;

    result = {
        "GET_PERFILES": JSON.parse(data.GET_PERFILES).Recordset0.Rows,
    }

    _dispatch({ type: GET_PERFILES_FROM_ALTA_MOD_USUARIO, result });
    _dispatch({ type: ADD_PERFIL_USUARIO_FROM_ALTA_MOD_USUARIO, perfilCodigo: _perfilCodigo, productId: _productoId });
}
